<template>
  <div>
    <select :id="id" class="select" v-model="selected" @change="onChange($event.target.value)">
      <option v-if="allYn == 'Y'" value='0'>전체</option>
      <option v-for="code in codeList" v-bind:key="code.code" :value='code.code'>{{ code.name }}</option>
    </select>      
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'selectInsuranceList',
  props: {
    label: "",
    id: {
      type: String,
      default: "selectInsurance"
    },
    name: {
      type: String,
      default: "selectInsurance"
    },
    allYn: {
      type: String,
      default: "Y"
    },    
    codeType: "",
    value : 0
  },
  data () { 
    return {
      codeList: []
    }
  },    
  computed: {
    selected : {
      get() {
        return this.value
      },
      set() { }
    }
  },  
  mounted: function () {
    //this.$nextTick(function() {
      let params = {
      //   codeType : this.codeType
      }

      Vue.httpClient
      .get('/common/insurance/list', {params : params})
      .then((result) => {
        for (let i in result.data.result) {
          this.codeList.push({code: result.data.result[i].insuranceNo, name: result.data.result[i].insuranceName})
        }

        if (this.allYn != 'Y' && this.value == '') {
          this.$nextTick(function() {
            this.$emit('input', result.data.result[0].insuranceNo);
          });  
        }
      })
    //});
  },
  methods: {
    onChange(value) {
      this.$emit('input', value);
      this.$emit('select-insurance-complete', value);
    }
  }  
}
</script>

<style scoped>
  div {
        display:inline;
  }
</style>


// WEBPACK FOOTER //
// src/components/SelectInsuranceList.vue